import {
  FaBook,
  FaLandmark,
  FaTree,
  FaWheelchair,
  FaParking,
  FaShoppingBasket,
  FaUtensils,
  FaWifi,
  FaUsers,
  FaCampground,
  FaPaw,
} from "react-icons/fa";

export const SITE_TAGS = [
  { name: "Library", icon: <FaBook /> },
  { name: "Museum", icon: <FaLandmark /> },
  { name: "Natural Park", icon: <FaTree /> },
  { name: "Wheelchair Accessible", icon: <FaWheelchair /> },
  { name: "Pet-Friendly", icon: <FaPaw /> },
  { name: "RV Parking", icon: <FaParking /> },
  { name: "Picnic Area", icon: <FaShoppingBasket /> },
  { name: "Large Group Friendly", icon: <FaUsers /> },
  { name: "Native American Centric", icon: <FaCampground /> },
  { name: "Guest WiFi", icon: <FaWifi /> },
  { name: "Restaurants Near By", icon: <FaUtensils /> },
];
